import { useState } from "react";
import { preconnect } from "react-dom";
import {
  changeStill,
  cityOfThirst,
  iAmCancer,
  infectedMind,
  lostInTheOcean,
  paradiseStill,
  playButton,
  watchBakgrundNy as watchBakgrund,
  watchLogga,
} from "../assets";
import { HomeButton, MuteToggle, SiteNav } from "../components/SiteChrome";
import { SocialIcons } from "../components/SocialIcons";
import { loadFonts } from "../fonts";
import { CITY_OF_THIRST_RELEASED } from "../release";
import { useBackgroundWrapper } from "../useBackgroundWrapper";
import "./Watch.css";

/**
 * `eager` is the first tile's, not City of Thirst's: it is the one above the
 * fold, and whichever video leads the grid has to carry it — hence the flag
 * being applied in the render rather than written into the list.
 */
const VIDEOS = [
  { id: "aUzzjOuue4A", thumb: paradiseStill, alt: "Paradise" },
  { id: "4mWtej-Wy8E", thumb: changeStill, alt: "Change" },
  { id: "9cba5Hk66-A", thumb: cityOfThirst, alt: "City of thirst", cityOfThirst: true },
  { id: "PwfusplARZg", thumb: lostInTheOcean, alt: "Lost in the ocean" },
  { id: "Vaaz__K4dxA", thumb: infectedMind, alt: "Infected mind" },
  { id: "EpdOEAuGbng", thumb: iAmCancer, alt: "I am cancer" },
];

export function Watch() {
  const { wrapperRef, imageRef, onLoad, wrapperClassName, wrapperStyle } =
    useBackgroundWrapper(watchBakgrund);
  // Each thumbnail is swapped for a real embed only on click — four autoloading
  // iframes would be a lot of YouTube on first paint.
  const [playing, setPlaying] = useState<Set<string>>(new Set());
  // Filtered here rather than at module scope so the flag is read on every
  // render — four items, and it keeps both states of ticket 039 testable.
  const videos = VIDEOS.filter((video) => CITY_OF_THIRST_RELEASED || !video.cityOfThirst);
  loadFonts();

  return (
    <div className="page-watch">
      {/* The backdrop the stack floats on, outside the wrapper so it covers the
          viewport rather than the artwork and does not wait on the wrapper's
          fade — the landing page's #home-sky, with this page's own sky. Same
          `src` as #bg-image below, so it is one cache entry and not a second
          download.

          `hidden` rather than a `display: none` in Watch.css, which ticket 025
          leaves byte-identical: the attribute is the UA stylesheet's own
          `display: none`, which any author rule outranks, so
          src/mobile/portrait-watch.css turns it on for the one viewport that wants it — a portrait phone —
          and every other viewport gets it off for free. Ticket 025. */}
      <img id="watch-sky" src={watchBakgrund} alt="" hidden />
      <div id="bg-wrapper" className={wrapperClassName} style={wrapperStyle} ref={wrapperRef}>
        <img
          id="bg-image"
          className="bg-image"
          ref={imageRef}
          onLoad={onLoad}
          src={watchBakgrund}
          alt=""
        />
        <img id="watch-title" src={watchLogga} alt="Watch" />
        <div id="video-stack">
          {videos.map(({ id, thumb, alt }, index) => (
            <div
              key={id}
              className={`video-item${playing.has(id) ? " playing" : ""}`}
              data-video-id={id}
              onClick={() => setPlaying((prev) => new Set(prev).add(id))}
              // The embed's DNS and TLS work starts while the finger is still
              // down, so it is not on the click path.
              onPointerDown={() => preconnect("https://www.youtube.com")}
            >
              <img
                className="video-thumb"
                src={thumb}
                alt={alt}
                loading={index === 0 ? "eager" : "lazy"}
                fetchPriority={index === 0 ? "high" : undefined}
              />
              {!playing.has(id) && (
                <>
                  <img className="play-button" src={playButton} alt="" />
                  <span className="video-title">{alt}</span>
                </>
              )}
              {playing.has(id) && (
                <iframe
                  src={`https://www.youtube.com/embed/${id}?autoplay=1`}
                  title="RIVER video"
                  allow="autoplay; encrypted-media; picture-in-picture"
                  allowFullScreen
                />
              )}
            </div>
          ))}
        </div>
        <SocialIcons />
      </div>

      <HomeButton />
      <MuteToggle />
      <SiteNav active="/watch" />
    </div>
  );
}
